import { useEffect, useState } from "react";
import Loader from "../util/Loader";
import LoadingAwal from "../util/LoadingAwal";
import { useLocation } from "react-router-dom";
import { Alert, AppBar, Avatar, Box, Button, Grid2, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from "@mui/material";
import axios from "axios";
import PaymentMethodNotFound from "./PaymentMethodNotFound";
import PaymentMethodXenplatform from "./PaymentMethodXenplatform";
import PaymentMethodXendit from "./PaymentMethodXendit";


const PayInvoice = () => {

    const [isLoad, setIsLoad] = useState(true);
    const [rows, setRows] = useState({});
    const location = useLocation();
    const noInvoice = new URLSearchParams(location.search).get('no_');
    const idUser = new URLSearchParams(location.search).get('u_');
    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: "404 - Failed"
    });
    const [viewMethod, setViewMethod] = useState("");

    useEffect(() => {
        const init = () => {
            axios.get(`https://ssr.radboox.com/data/invoice/client_pay_new/${idUser}?no=${noInvoice}`)
            .then((res) => {
                const data = res.data.message;
                setRows(data)
                setIsLoad(false)
            }).catch((e) =>{
                setIsLoad(false)
            })
        }
        init();
    }, [noInvoice, idUser])

    const getViewGateway = (rows) => {
        switch(rows.gateway.name) {
            case 'xenplatform' :
                setViewMethod(<PaymentMethodXenplatform idUser={idUser} id={rows.id} setIsLoad={setIsLoad} state={state} setState={setState} />)
                break;
            case 'xendit' :
                setViewMethod(<PaymentMethodXendit idUser={idUser} id={rows.id} setIsLoad={setIsLoad} state={state} setState={setState} channel={rows.gateway.channel}/>)
                break;
            default :
                setViewMethod(<PaymentMethodNotFound />)
                break;
        }
    }

    useEffect(() => {
        const init = () => {
            if(Object.keys(rows).length > 0) {
                getViewGateway(rows);
            }
        };
        init();
    }, [rows])

    const getFee = () => {
        const fee = rows.gateway.fees;
        if(fee !== "") {
            return (
                <TableRow>
                    <TableCell align="right"> Fee</TableCell>
                    <TableCell align="right" sx={{fontWeight:500}}>{fee}</TableCell>
                </TableRow>
            )
        }
    }

    const handleCloseSnackbar = () => {
        setState({ ...state, open: false });
      };
    

    return (
        <>
        {isLoad ? (
            <>
                <Loader />
                <LoadingAwal /> 
            </>) : (
            <>
                {Object.keys(rows).length > 0 ? (
                    <>
                    {rows.status === 1 ? (
                    <>
                        <Box className="noPrint" marginTop={2}>
                            <AppBar position="fixed" sx={{bgcolor: "#1f283e"}}>
                                <Toolbar>
                                    <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/radboox-icon.png'} />
                                    <Typography
                                        variant="h6"
                                        noWrap
                                        component="a"
                                        href="https://www.radboox.com"
                                        sx={{
                                            mx: 2,
                                            fontSize: "26px",
                                            fontFamily: 'Roboto',
                                            fontWeight: 700,
                                            color: 'inherit',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        RadbooX
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <Toolbar />
                        </Box>
                        <Box sx={{margin: 2}}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={{xs: 12, sm: 6}}>
                                    <img
                                        src={`https://content.radboox.com/public/upload/img/${rows.cp_logo}`}
                                        alt="Company Profile"
                                        style={{
                                            align: "left",
                                            maxHeight: "70px",
                                            objectFit: "contain",
                                            backgroundColor: "#fff",
                                        }}
                                    />
                                    <Typography variant="h6" sx={{fontWeight: 800}}>{rows.cp_name}</Typography>
                                    <Typography sx={{marginTop: 3}}>Hi {rows.fullName},</Typography>
                                    <Typography variant="body1" sx={{fontWeight: 500}} display="inline">Pay Invoice #{rows.noInvoice} - </Typography>
                                    <Typography variant="h6" sx={{fontWeight: 700, lineHeight: 0.5}} display="inline"> Rp {rows.gateway.total || 0}</Typography>
                                    {viewMethod}
                                </Grid2>
                                <Grid2 size={{xs: 12, md: 6}}>
                                    <Box sx={{bgcolor: "#f0ecec50"}} align={"center"}>
                                        <Typography align="center" sx={{paddingY: 2}}>Summary</Typography>
                                        <TableContainer>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Description</TableCell>
                                                        <TableCell align="right">Amount (Rp)</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>
                                                            {rows.item}
                                                        </TableCell>
                                                        <TableCell align="right" sx={{fontWeight:500}}>{rows.amount}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="right">Sub Total</TableCell>
                                                        <TableCell align="right" sx={{fontWeight:500}}>{rows.amount}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="right">PPN</TableCell>
                                                        <TableCell align="right" sx={{fontWeight:500}}>{rows.ppn}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell align="right">Discount</TableCell>
                                                        <TableCell align="right" sx={{fontWeight:500}}>{rows.diskon}</TableCell>
                                                    </TableRow>
                                                    {getFee()}
                                                    <TableRow>
                                                        <TableCell align="right" sx={{fontWeight:700}}>Total</TableCell>
                                                        <TableCell align="right" sx={{fontWeight:700}}>{rows.gateway.total || 0}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        <Button style={{textTransform: 'none'}} sx={{marginY: 2, color: "inherit"}} variant="text" size="small" component="a" href={`https://www.radboox.com/users/invoice/pr?u_=${idUser}&id_=${rows.id}`} >View Invoice</Button>
                                    </Box>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </>
                    ) : (
                    <>
                        <Box className="noPrint" marginTop={2}>
                            <AppBar position="fixed" sx={{bgcolor: "#1f283e"}}>
                                <Toolbar>
                                    <Avatar alt="Remy Sharp" src={process.env.PUBLIC_URL + '/radboox-icon.png'} />
                                    <Typography
                                        variant="h6"
                                        noWrap
                                        component="a"
                                        href="https://www.radboox.com"
                                        sx={{
                                            mx: 2,
                                            fontSize: "26px",
                                            fontFamily: 'Roboto',
                                            fontWeight: 700,
                                            color: 'inherit',
                                            textDecoration: 'none',
                                        }}
                                    >
                                        RadbooX
                                    </Typography>
                                </Toolbar>
                            </AppBar>
                            <Toolbar />
                        </Box>
                        <Box display="flex" flexDirection="column" justifyContent='center' alignItems='center'>
                            <Typography variant="h4" sx={{fontWeight: 800}}>Thank You!</Typography>
                            <Typography variant="h6">Your order has been paid successfully</Typography>
                            <Typography variant="body2" align="center" sx={{paddingTop: 2}}>Summary</Typography>
                            <Typography>No. Invoice : 
                                <Button style={{textTransform: 'none'}} sx={{margin: 0, color: "inherit", fontSize: 18, padding: 0}} variant="text" size="small" component="a" href={`https://www.radboox.com/users/invoice/pr?u_=${idUser}&id_=${rows.id}`} >#{rows.noInvoice}</Button>
                            </Typography>
                            <Typography>Paid Date : {rows.paid_date}</Typography>
                            <Typography variant="h5" sx={{paddingTop: 5, fontWeight: 800}}>~ {rows.cp_name} ~</Typography>
                        </Box>
                    </>
                    )}
                    </>
                ) : (
                    <>
                        <Box sx={{width: "100%", height: "70vh"}} display="flex" flexDirection="column" justifyContent='center' alignItems='center'>
                            <Typography variant="h2">404</Typography>
                            <Typography variant="h6">Invoice not found</Typography>
                        </Box>
                    </>
                )}
            </>
        )}
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            open={state.open}
            key="center"
            autoHideDuration={5000}
            onClose={handleCloseSnackbar}
          >
            <Alert
              onClose={handleCloseSnackbar}
              severity={"error"}
              // variant="outlined"
              variant="filled"
              sx={{ width: "100%" }}
            >
              {state.message}
            </Alert>
          </Snackbar>
        </>
    )
}

export default PayInvoice;